import React from 'react';
import { Button, Col, Form, Input, Row } from 'antd';
import { Footer } from "antd/es/layout/layout";
import { Image } from 'antd';
import easebuzzlogo from '../assets/images/easebuzzlogo.svg';
import Header from '../common/Layouts/AppLayout/Header';
import './index.css';

const CustomerLandingPage = ({ customerForm, callCustomerDetailsAPI, customer_search_box_label, customer_search_box_note,search_box_placeholder_label }) => {
  return (
    <div className="background-image">
    <div className="grid-container">
      <div className="centered-content">
        <Header />
        <Row justify="center" align="middle" className="customer_page">
          <Col xs={24} sm={20} md={18} lg={12} xl={10} xxl={8}>
            <div className="card-first">
              <span className="heading">Enter {customer_search_box_label}</span>
              <Form
                name="customerForm"
                layout="vertical"
                form={customerForm}
                onFinish={callCustomerDetailsAPI}
                autoComplete="off"
              >
                <Form.Item
                  className="flat-input input-field"
                  name="customer_id"
                  rules={[
                    {
                      required: true,
                      message: `Please enter your ${customer_search_box_label}`,
                    },
                  ]}
                  style={{ textAlign: 'left' }}
                >
                  <Input className='Input' size="large" placeholder={search_box_placeholder_label} />
                </Form.Item>
                <span className="input-field-text" style={{ color: "#8F93A8", textAlign: "center" }}>
                  {customer_search_box_note}
                </span>
                <Form.Item>
                  <Button className="submit-btn" size="large" block htmlType="submit">
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
            <Footer className="custom-footer" style={{background: "transparent"}}>
              <Image className='pwrdByEasebuzz' src={easebuzzlogo} alt="" preview={false} />
            </Footer>
          </Col>
        </Row>
      </div>
    </div>
    </div>
  );
};

export default CustomerLandingPage;
